var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, OnDestroy, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { DriveState } from './state/drive-state';
import { DriveDomCacheService } from './interactions/drive-dom-cache.service';
import { Observable } from 'rxjs';
import { LoadUserFolders, LoadUserSpaceUsage, ResetState, SetCurrentUser, SetViewMode, ToggleSidebar, UploadFiles } from './state/actions/commands';
import { Settings } from 'common/core/config/settings.service';
import { CurrentUser } from 'common/auth/current-user';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BreakpointChanged } from './state/actions/events';
import { VIEW_MODE_KEY } from './state/models/drive-state-model';
import { LocalStorage } from 'common/core/services/local-storage.service';
var DriveComponent = /** @class */ (function () {
    function DriveComponent(store, route, currentUser, localStorage, domCache, breakpoints, settings) {
        this.store = store;
        this.route = route;
        this.currentUser = currentUser;
        this.localStorage = localStorage;
        this.domCache = domCache;
        this.breakpoints = breakpoints;
        this.settings = settings;
        this.subscriptions = [];
    }
    DriveComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setViewMode();
        this.cacheDemoElements();
        this.observeBreakpointChanges();
        this.store.dispatch(new LoadUserFolders());
        this.store.dispatch(new LoadUserSpaceUsage());
        // TODO: refactor this once auth is moved to it's own store
        this.store.dispatch(new SetCurrentUser(this.currentUser.getModel()));
        this.currentUser.userChanged.subscribe(function (user) {
            _this.store.dispatch(new SetCurrentUser(user));
        });
    };
    DriveComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(ResetState);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions = [];
    };
    DriveComponent.prototype.uploadFiles = function (files) {
        this.store.dispatch(new UploadFiles(files));
    };
    DriveComponent.prototype.toggleSidebar = function () {
        this.store.dispatch(new ToggleSidebar());
    };
    DriveComponent.prototype.cacheDemoElements = function () {
        this.domCache.filesCont = this.filesContainer.nativeElement;
        this.domCache.scrollCont = this.scrollContainer.nativeElement;
        this.domCache.dragPreview = this.dragPreview.nativeElement;
    };
    DriveComponent.prototype.setViewMode = function () {
        this.store.dispatch(new SetViewMode(this.localStorage.get(VIEW_MODE_KEY, 'grid')));
    };
    DriveComponent.prototype.observeBreakpointChanges = function () {
        var _this = this;
        var sub = this.breakpoints.observe('(max-width: 1100px)').subscribe(function (result) {
            _this.store.dispatch(new BreakpointChanged({ isMobile: result.matches }));
        });
        this.subscriptions.push(sub);
    };
    __decorate([
        Select(DriveState.dragging),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "dragging", void 0);
    __decorate([
        Select(DriveState.detailsOpen),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "activityOpen$", void 0);
    __decorate([
        Select(DriveState.sidebarOpen),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "sidebarOpen$", void 0);
    __decorate([
        Select(DriveState.loading),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "loading$", void 0);
    __decorate([
        Select(DriveState.isMobile),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "isMobile$", void 0);
    __decorate([
        Select(DriveState.canUpload),
        __metadata("design:type", Observable)
    ], DriveComponent.prototype, "canUpload$", void 0);
    return DriveComponent;
}());
export { DriveComponent };
